import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { mergeInitialValues } from '@utils/formik';

import { useFormParams, useFormValues } from '../HealthQuoteBuyForm';
import { selectHealthQuoteBuyRoute } from '../selector';

export const useInitialValues = () => {
  const { healthQuote } = useSelector(selectHealthQuoteBuyRoute);
  const params = useFormParams();
  const values = useFormValues();
  return useMemo(() => {
    if (!healthQuote) return;
    const { members, commissionShares } = healthQuote;
    return mergeInitialValues(
      values,
      members,
      params,
      commissionShares ? { commissionShares } : undefined,
    );
  }, [healthQuote]);
};
